// export const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
export const alphabet = "ئابپتثصطضذظجچحخدرڕزژسشغفڤقكگلڵمنوۆهەیيێ".split("");
// export const alphabet = "ABCÇDÊFGHIÎJKLMNOPQRSŞTVUWXYZ".split("");